<template>
  <main class="main page-inside">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="content">

            <div class="content__head">
              <div class="head__title title">
                Your order has been placed
              </div>
              <div class="head__refresh">

              </div>
            </div>

            <div class="content__container">
              <div class="info-left">
                <div class="checkout-step-list">
                  <div class="checkout-step-list__item">
                    <div class="checkout-step__title title">
                      #{{ order.order_nr }}
                    </div>

                    <div class="notice">
                      <div class="notice__wrapper">
                        <div class="title">{{ order.amount }} {{ takeCurrency }}</div>
                        <div class="desc">
                          For {{ Number.parseFloat(order.dest_amount || 0).toFixed(2) }} {{ currencySymbol }}
                        </div>
                      </div>
                    </div>

                    <div class="desc">
                      To complete your order, please follow steps provided below.
                    </div>
                  </div>
                </div>
              </div>

              <div class="info-right">
                <div class="checkout-step-list">
                  <div class="checkout-step-list__item checkout-step-list__item_bank_details">
                    <div class="checkout-step__title title">
                      01. Check if the order information correct
                    </div>

                    <div class="checkout-step__title_sell_orders title">
                      Sell orders detail
                    </div>

                    <div class="details-list">
                      <div class="details-list__item">
                        <div class="item-desc desc">
                          Sender name
                        </div>
                        <div class="item-value title">
                          {{ order.name }} {{ order.surname }}
                        </div>
                      </div>
                      <div class="details-list__item">
                        <div class="item-desc desc desc">
                          Sender account number
                        </div>
                        <div class="item-value title">
                          {{ order.iban }}
                        </div>
                      </div>
                      <div class="details-list__item">
                        <div class="item-desc desc">
                          Bank name
                        </div>
                        <div class="item-value title">
                          {{ order.bank_name }}
                        </div>
                      </div>
                      <div class="details-list__item">
                        <div class="item-desc desc">
                          Cryptocurrency
                        </div>
                        <div class="item-value title">
                          {{ cryptocurrency }}
                        </div>
                      </div>
                      <div class="details-list__item">
                        <div class="item-desc desc">
                          Network
                        </div>
                        <div class="item-value title">
                          {{ network }}
                        </div>
                      </div>
                      <div class="details-list__item">
                        <div class="item-desc desc">
                          Deposit address
                        </div>
                        <div class="item-value title">
                          {{ order.deposit_wallet }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="checkout-step-list__item checkout-step-list__item_send_crypto">
                    <div class="checkout-step__title title">
                      02. Send cryptocurrency to our deposit wallet
                    </div>

                    <div class="checkout-step__desc desc">
                      It may take a few days to process the transaction. The speed of funds being credited to your bank
                      account also depends on your bank's processing speed.
                    </div>

                    <div class="checkout-step__desc desc">
                      We'll notify you via email after sending the funds to your bank account.
                    </div>
                  </div>
                </div>

                <div class="actions">
                  <div class="actions__buttons">
                    <button type="button" :disabled="cancelling" @click="cancelOrder" :class="['button', 'gray', {disabled: cancelling}]">
                      Cancel
                    </button>
                    <router-link :to="{name: 'BuyCrypto'}" type="submit" :class="['button']">
                      Continue
                    </router-link>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <!--            <div class="card-list">-->
          <!--              <template v-if="!$parent.checkoutSuccess" >-->
          <!--              <div class="card-list__item order-details">-->
          <!--                <div class="title small">Order details</div>-->
          <!--                <div class="desc">Choose payment method:</div>-->
          <!--                <div class="radio-list">-->
          <!--                  <div class="list">-->
          <!--                    <div class="item"></div>-->
          <!--                    <div class="item">-->
          <!--                      <label>-->
          <!--                        <input v-if="$parent.fiatToCrypto" type="radio" v-model="$parent.paymentMethod" name="paymentMethod" value="card"/>-->
          <!--                        <input v-else type="radio" v-model="$parent.paymentMethod" name="paymentMethod" value="crypto"/>-->
          <!--                        <div class="text">-->
          <!--                          <svg v-if="$parent.fiatToCrypto" class="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.667 17.841">-->
          <!--                            <g id="Layer_1" transform="translate(-2.13 -5.896)">-->
          <!--                              <path id="Контур_12558" data-name="Контур 12558" d="M6.467,23.737h16A4.338,4.338,0,0,0,26.8,19.4V10.229A4.338,4.338,0,0,0,22.464,5.9h-16a4.338,4.338,0,0,0-4.333,4.333v1.544c0,.008,0,.014,0,.021s0,.014,0,.021V19.4a4.338,4.338,0,0,0,4.333,4.333Zm16-1.766h-16A2.57,2.57,0,0,1,3.9,19.4V12.678H25.031V19.4A2.57,2.57,0,0,1,22.464,21.972Zm-16-14.31h16a2.57,2.57,0,0,1,2.567,2.567v.683H3.9v-.683A2.57,2.57,0,0,1,6.467,7.662Z" transform="translate(0 0)" fill="#7f8798"/>-->
          <!--                              <path id="Контур_12559" data-name="Контур 12559" d="M10.865,20.469H6.737a.883.883,0,1,0,0,1.766h4.128a.883.883,0,0,0,0-1.766Z" transform="translate(-0.436 -1.707)" fill="#7f8798"/>-->
          <!--                            </g>-->
          <!--                          </svg>-->
          <!--                          <div class="desc">{{ $parent.fiatToCrypto ? 'Visa/Mastercard' : 'Crypto' }} </div>-->
          <!--                        </div>-->
          <!--                      </label>-->
          <!--                    </div>-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--                <div class="input-container">-->
          <!--                  <div class="desc">Wallet:</div>-->
          <!--                  <input type="text" v-model="wallet"/>-->
          <!--                  <div class="clue">The wallet you'll pay from</div>-->
          <!--                </div>-->
          <!--                <div class="total">-->
          <!--                  <div class="desc">Total amount to pay:</div>-->
          <!--                  <div class="total-wrapper">-->
          <!--                    <div class="item">-->
          <!--                      <div class="text">-->
          <!--                        <div class="desc">Date of order</div>-->
          <!--                        <div class="desc">{{currentDate}}</div>-->
          <!--                      </div>-->
          <!--                      <div class="title" :class="{'crypto': !$parent.fiatToCrypto}">{{ leftAmount }}</div>-->
          <!--                    </div>-->
          <!--                    <div class="item">-->
          <!--                      <div class="text">-->
          <!--                        <div class="desc">Exchange rate</div>-->
          <!--                        <div class="desc">{{$parent.takeCurrency.crypto_currency}} = {{$parent.takeCurrency.price}} {{$parent.giveCurrency.symbol}}</div>-->
          <!--                      </div>-->
          <!--                      <div class="title" :class="{'crypto': $parent.fiatToCrypto}">{{ rightAmount }}</div>-->
          <!--                    </div>-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--                <div class="total-bottom">-->
          <!--                  <router-link to="buy-crypto" class="button gray">Cancel order</router-link>-->
          <!--                  <button class="button" :disabled="!wallet" @click="submit">Continue</button>-->
          <!--                </div>-->
          <!--              </div>-->

          <!--              <div class="card-list__item-container">-->
          <!--                <div class="card-list__item your-card">-->
          <!--                  <div class="title small">Your Card</div>-->
          <!--                  <div class="row">-->
          <!--                    <div class="title">{{ leftAmount }}</div>-->
          <!--                    <router-link to="buy-crypto" class="button gray">Change amount</router-link>-->
          <!--                  </div>-->
          <!--                  <div class="desc">{{ rightAmount }}</div>-->
          <!--                  <div class="table">-->
          <!--                    <div class="row">-->
          <!--                      <div class="desc">Exchange rate</div>-->
          <!--                      <div class="desc">1 {{$parent.takeCurrency.crypto_currency}} = {{$parent.takeCurrency.price}} {{$parent.giveCurrency.symbol}}</div>-->
          <!--                    </div>-->
          <!--                    <div class="row">-->
          <!--                      <div class="desc">{{ $parent.fiatToCrypto ? 'Coins' : 'Money' }} to receive</div>-->
          <!--                      <div class="desc">{{ rightAmount }}</div>-->
          <!--                    </div>-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--                <div class="timer">-->
          <!--                  <div class="title">{{ hours }}:{{ minutes }}:{{ seconds }}</div>-->
          <!--                  <div class="desc">The price is fixes for 1 hour</div>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--              </template>-->
          <!--              <template v-else>-->
          <!--                <div class="card-list__item order-success">-->
          <!--                  <div class="order-submit-success">-->
          <!--                    <div class="order-submit-success__title">Order successfully submitted</div>-->
          <!--                    <div class="order-submit-success__message">-->
          <!--                    </div>-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--              </template>-->
          <!--            </div>-->
        </div>
      </div>
    </div>

  </main>
</template>
<script>

export default {
  name: 'OrderDetails',
  props: [],
  components: {},
  data: function () {
    return {
      paymentMethod: 'visaMastercard',
      wallet: '',
      hours: 1,
      minutes: 0,
      seconds: 0,
      timer: null,
      currentDate: '',
      submitSuccess: false,
      order: {},
      cancelling: false
    }
  },
  mounted: async function () {
    // this.$parent.changeCheckoutSuccess(false);
    // this.startTimer();
    // this.getCurrentDate();
    await this.fetchOrder()
  },
  methods: {
    async fetchOrder() {
      try {
        const {
          data: {
            payload: {
              order
            }
          }
        } = await this.$http.get(process.env.VUE_APP_API + `orders/${this.$route.params.id}`);

        this.order = order;
      } catch (e) {
        console.error(e);
      }
    },
    getCurrentDate() {
      const today = new Date();
      const formattedDate = today.toISOString().split('T')[0];

      this.currentDate = formattedDate;
    },
    startTimer() {
      this.timer = setInterval(() => {
        if (this.hours === 0 && this.minutes === 0 && this.seconds === 0) {
          clearInterval(this.timer);
        } else {
          if (this.seconds > 0) {
            this.seconds--;
          } else {
            if (this.minutes > 0) {
              this.minutes--;
              this.seconds = 59;
            } else {
              this.hours--;
              this.minutes = 59;
              this.seconds = 59;
            }
          }
        }
      }, 1000);
    },
    async cancelOrder() {
      try {
        this.cancelling = true;
        await this.$http.put(process.env.VUE_APP_API + `orders/${this.$route.params.id}/cancel`);
        this.$toast('Order successfully cancelled.', {type: 'success'});
        await this.$router.push({ name: 'BuyCrypto' });
      } catch (e) {
        console.error(e);

        const errorMessage = e.response?.data?.message || 'Failed to cancel order. Please try again.';
        this.$toast(errorMessage, { type: 'error' });
      } finally {
        this.cancelling = false;
      }
    },
    submit() {
      this.$emit('setWallet', this.wallet)
      this.$emit('orderSubmit');
    }
  },
  computed: {
    takeCurrency() {
      let currency = this.order.source_asset || '';

      if (currency?.endsWith("_erc")) {
        currency = currency.replace('_erc', '').replace('_', ' ') + '/ERC-20'
      } else if (currency?.endsWith("_trc")) {
        currency = currency.replace('_trc', '').replace('_', ' ') + '/TRC-20'
      }

      return currency.toUpperCase();
    },
    currencySymbol() {
      let currency = this.order.dest_asset || '';

      if (currency === 'USD') {
        return '$';
      } else if (currency === 'EUR') {
        return '€'
      }

      return currency.toUpperCase();
    },
    cryptocurrency() {
      console.log(this.order.source_asset);

      if (this.order && this.order.source_asset) {
        const asset = this.order.source_asset;

        if (asset.startsWith('usdt')) {
          return 'Tether (USDT)'
        } else {
          return asset.charAt(0).toUpperCase() + asset.slice(1);
        }
      }

      return '';
    },
    network() {
      if (this.order && this.order.source_asset) {
        const asset = this.order.source_asset;

        if (asset.endsWith('trc')) {
          return 'TRC - 20';
        } else if (asset.endsWith('erc')) {
          return 'ERC - 20';
        }
      }

      return '';
    }
  }
}
</script>